export enum ELoanPurposeFieldName {
  CHECK_PICKER = 'agent',
}
